import { useCallback } from "react";
import { ref, set, remove } from "firebase/database";
import { db } from "../api/firebase";
import { useAuth } from "../helpers/Auth";
import { useNavigate } from "react-router";
import uuid from "react-uuid";

const useInventoryActions = () => {
  const { effectiveUID } = useAuth();
  const navigate = useNavigate();

  const userPath = () => `/userdata/${effectiveUID}`;

  const createInventoryItem = useCallback(
    (formProps: any, allowNavigate: boolean = false) => {
      formProps.id = uuid();
      set(ref(db, userPath() + `/inventory/${formProps.id}`), {
        ...formProps,
      });
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  const editInventoryItem = useCallback(
    (id: string, formProps: any, allowNavigate: boolean = false) => {
      formProps.id = id;
      set(ref(db, userPath() + `/inventory/${formProps.id}`), {
        ...formProps,
      });
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  const deleteInventoryItem = useCallback(
    (id: string, allowNavigate: boolean = false) => {
      remove(ref(db, userPath() + `/inventory/${id}`));
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  return { createInventoryItem, editInventoryItem, deleteInventoryItem };
};

export default useInventoryActions;
